// Extracts the numeric lot database ID from a URL slug.
// Slugs are generated as kebabCase(`${lot.id}-${lot.name}`), so the format is typically
// `${numericId}-${name-parts}`. Some printed QR codes or legacy links may omit the numeric
// id and use only the display code (e.g. "L-122", "177U"), in which case we look for the
// first purely numeric segment instead of blindly taking [0].
const parseLotSlug = slug => {
  if (!slug) return null

  const segments = String(slug).split('-')

  for (const segment of segments) {
    const match = segment.match(/^(\d+)/)

    if (match) {
      return parseInt(match[1], 10)
    }
  }

  return null
}

export default parseLotSlug
